import { EventEmitter, Component, Input, Output, ViewChild, NgModule, ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwalPortalTargets, SweetAlert2LoaderService, SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { from } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@sweetalert2/ngx-sweetalert2';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["swal"];
function ModalWrapperComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} }
function ModalWrapperComponent_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function ModalWrapperComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵtemplate(2, ModalWrapperComponent_ng_container_5_div_2_Template, 1, 0, "div", 5);
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("swalPortal", ctx_r2.swalTargets.actions);
} }
const _c1 = ["*"];
class ModalOptions {
    constructor(options = {}) {
        this.customClass = {};
        Object.assign(this, options);
    }
    get cancelButtonClass() {
        var _a;
        return (_a = this.customClass) === null || _a === void 0 ? void 0 : _a.cancelButton;
    }
    set cancelButtonClass(value) {
        Object.assign(this.customClass, { cancelButton: value });
    }
    get confirmButtonClass() {
        var _a;
        return (_a = this.customClass) === null || _a === void 0 ? void 0 : _a.confirmButton;
    }
    set confirmButtonClass(value) {
        Object.assign(this.customClass, { confirmButton: value });
    }
    get denyButtonClass() {
        var _a;
        return (_a = this.customClass) === null || _a === void 0 ? void 0 : _a.denyButton;
    }
    set denyButtonClass(value) {
        Object.assign(this.customClass, { denyButton: value });
    }
    get customContainerClass() {
        var _a;
        return (_a = this.customClass) === null || _a === void 0 ? void 0 : _a.container;
    }
    set customContainerClass(value) {
        Object.assign(this.customClass, { container: value });
    }
    get type() {
        return this.icon;
    }
    set type(value) {
        this.icon = value;
    }
}

class ModalWrapperComponent {
    constructor(swalTargets, loaderService) {
        this.swalTargets = swalTargets;
        this.loaderService = loaderService;
        this.allowOutsideClick = false;
        this.title = '';
        this.autoShow = true;
        this.showActions = true;
        this.ready = new EventEmitter();
        this.okClick = new EventEmitter();
        this.cancelClick = new EventEmitter();
    }
    handleSwalClick(response) {
        if (response.value) {
            this.okClick.emit();
        }
        else {
            this.cancelClick.emit();
        }
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.autoShow) {
                this.openSwal();
            }
            this.ready.emit({
                close: () => {
                    this.swal.dismiss().then();
                },
                show: () => {
                    this.openSwal();
                },
            });
        }, 0);
    }
    ngOnDestroy() {
        this.swal.dismiss().then();
    }
    openSwal() {
        this.swal.swalOptions = new ModalOptions(this.options);
        this.swal.fire().then((response) => {
            if (response.value) {
                this.okClick.emit();
            }
            else {
                this.cancelClick.emit();
            }
        });
    }
}
ModalWrapperComponent.ɵfac = function ModalWrapperComponent_Factory(t) { return new (t || ModalWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SwalPortalTargets), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SweetAlert2LoaderService)); };
ModalWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalWrapperComponent, selectors: [["modal-wrapper"]], viewQuery: function ModalWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.swal = _t.first);
    } }, inputs: { allowOutsideClick: "allowOutsideClick", title: "title", autoShow: "autoShow", showActions: "showActions", options: "options" }, outputs: { ready: "ready", okClick: "okClick", cancelClick: "cancelClick" }, ngContentSelectors: _c1, decls: 8, vars: 4, consts: [[3, "allowOutsideClick", "title"], ["swal", ""], ["class", "swal2-content", 4, "swalPortal"], [4, "ngIf"], [1, "swal2-content"], [4, "swalPortal"]], template: function ModalWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "swal", 0, 1);
        ɵngcc0.ɵɵtext(2, "\n    ");
        ɵngcc0.ɵɵtemplate(3, ModalWrapperComponent_div_3_Template, 4, 0, "div", 2);
        ɵngcc0.ɵɵtext(4, "\n    ");
        ɵngcc0.ɵɵtemplate(5, ModalWrapperComponent_ng_container_5_Template, 4, 1, "ng-container", 3);
        ɵngcc0.ɵɵtext(6, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("allowOutsideClick", ctx.allowOutsideClick)("title", ctx.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("swalPortal", ctx.swalTargets.content);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showActions);
    } }, directives: [ɵngcc1.SwalComponent, ɵngcc1.SwalPortalDirective, ɵngcc2.NgIf], encapsulation: 2 });
ModalWrapperComponent.ctorParameters = () => [
    { type: SwalPortalTargets },
    { type: SweetAlert2LoaderService }
];
ModalWrapperComponent.propDecorators = {
    allowOutsideClick: [{ type: Input }],
    title: [{ type: Input }],
    options: [{ type: Input }],
    autoShow: [{ type: Input }],
    showActions: [{ type: Input }],
    ready: [{ type: Output }],
    okClick: [{ type: Output }],
    cancelClick: [{ type: Output }],
    swal: [{ type: ViewChild, args: ['swal', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'modal-wrapper',
                template: "<swal #swal [allowOutsideClick]=\"allowOutsideClick\" [title]=\"title\">\n    <div *swalPortal=\"swalTargets.content\" class=\"swal2-content\">\n        <ng-content></ng-content>\n    </div>\n    <ng-container *ngIf=\"!showActions\">\n        <div *swalPortal=\"swalTargets.actions\"></div>\n    </ng-container>\n</swal>\n"
            }]
    }], function () { return [{ type: ɵngcc1.SwalPortalTargets }, { type: ɵngcc1.SweetAlert2LoaderService }]; }, { allowOutsideClick: [{
            type: Input
        }], title: [{
            type: Input
        }], autoShow: [{
            type: Input
        }], showActions: [{
            type: Input
        }], ready: [{
            type: Output
        }], okClick: [{
            type: Output
        }], cancelClick: [{
            type: Output
        }], options: [{
            type: Input
        }], swal: [{
            type: ViewChild,
            args: ['swal', { static: true }]
        }] }); })();

class ModalModule {
}
ModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ModalModule_Factory(t) { return new (t || ModalModule)(); }, imports: [[CommonModule, SweetAlert2Module.forRoot()]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModalWrapperComponent]; }, imports: function () { return [CommonModule, ɵngcc1.SweetAlert2Module]; }, exports: function () { return [ModalWrapperComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [ModalWrapperComponent],
                exports: [ModalWrapperComponent],
                imports: [CommonModule, SweetAlert2Module.forRoot()]
            }]
    }], null, null); })();

class ModalService {
    constructor(sweetAlert2Loader) {
        this.sweetAlert2Loader = sweetAlert2Loader;
    }
    showModal(options = {}) {
        options = new ModalOptions(options);
        return from(this.sweetAlert2Loader.swal).pipe(concatMap((swal) => from(swal.fire(options))));
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc1.SweetAlert2LoaderService)); };
ModalService.ɵprov = ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(ɵɵinject(SweetAlert2LoaderService)); }, token: ModalService, providedIn: "root" });
ModalService.ctorParameters = () => [
    { type: SweetAlert2LoaderService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.SweetAlert2LoaderService }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ModalModule, ModalOptions, ModalService, ModalWrapperComponent as ɵa };

//# sourceMappingURL=mt-ng2-modal-module.js.map